import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { getFileUrl } from '../../lib/api';

export const HeroSliderV4 = ({ slides = [] }) => {
  const [current, setCurrent] = useState(0);

  const nextSlide = useCallback(() => {
    if (slides.length > 0) setCurrent(prev => (prev + 1) % slides.length);
  }, [slides.length]);

  useEffect(() => {
    if (slides.length <= 1) return;
    const timer = setInterval(nextSlide, 7000);
    return () => clearInterval(timer);
  }, [nextSlide, slides.length]);

  if (slides.length === 0) return <div className="w-full h-screen bg-[#0a0a0a] flex items-center justify-center"><p className="text-gray-500">Slider görsel eklenmemiş</p></div>;

  const slide = slides[current];
  return (
    <div className="relative w-full h-screen bg-[#0a0a0a] overflow-hidden" data-testid="home-hero-carousel-v4">
      {/* Subtle background image */}
      <div className="absolute inset-0 opacity-20">
        <img src={getFileUrl(slide.image_path)} alt="" className="w-full h-full object-cover" />
      </div>
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-[#0a0a0a]/70" />
      {/* Content - centered large text */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
        <div className="w-12 h-0.5 bg-[hsl(var(--gold))] mb-8" />
        <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-white mb-4 max-w-4xl leading-tight">{slide.title}</h1>
        {slide.subtitle && <p className="text-lg sm:text-xl text-gray-400 mb-10 max-w-2xl tracking-wide">{slide.subtitle}</p>}
        {slide.link && <Link to={slide.link} className="px-10 py-4 border border-[hsl(var(--gold))] text-[hsl(var(--gold))] font-medium text-sm tracking-widest uppercase hover:bg-[hsl(var(--gold))] hover:text-black transition-all duration-300">{slide.button_text || 'Keşfet'}</Link>}
        <div className="w-12 h-0.5 bg-[hsl(var(--gold))] mt-8" />
        {slides.length > 1 && <div className="absolute bottom-10 flex gap-3">{slides.map((_, i) => <button key={i} onClick={() => setCurrent(i)} className={`transition-all ${i === current ? 'w-8 h-1 bg-[hsl(var(--gold))]' : 'w-4 h-1 bg-white/30'} rounded-full`} />)}</div>}
      </div>
    </div>
  );
};
